import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { faAnglesLeft, faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { search, sort, selectInteraction } from '../../redux/interactionsSlice';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import HistoryChats from 'src/components/chat/historychats';
import LiveChats from 'src/components/chat/livechats';
import 'src/css/interactions/interactions.css';
import { Outlet } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import PostponedChats from '../chat/postponedchats';

const Views = {
    CHAT: 'chat',
    ONHOLD: 'onhold',
    HISTORY: 'history'
};

class Interactions extends Component {

    constructor(props) {
        super(props)

        this.state = {
            width: 8,
            icon: faAnglesLeft,
            left: -30,
            view: Views.CHAT,
            history: null
        };

        this.showHistory = this.showHistory.bind(this);
        this.showChats = this.showChats.bind(this);
    }

    componentDidUpdate() {

        if (window.location.hash.endsWith("chat") && this.state.view !== Views.CHAT)
            this.showChats();

        if (window.location.hash.endsWith("history") && this.state.view !== Views.HISTORY)
            this.showHistory();
    }

    showHistory = e => {
        this.props.navigate(Views.HISTORY);
        this.setState({ view: Views.HISTORY });
    }

    showChats = e => {
        this.props.navigate(Views.CHAT);
        this.setState({ view: Views.CHAT });
    }

    showOnHold = e => {
        this.props.navigate(Views.ONHOLD);
        this.setState({ view: Views.ONHOLD });
    }

    handleClick = id => {
        let width = 8,
            icon = faAnglesLeft,
            left = -30;
        if (this.state.width === 8) {
            width = 10;
            icon = faAnglesRight;
            left = -5;
        }

        this.setState({
            width: width,
            icon: icon,
            left: left
        });
    }

    render() {
        return (
            <Row>
                <Col xs={3} className={`interaction-list`}>
                    <Row >
                        <Col className={
                            "fs-4 pb-3 " +
                            (this.state.view === Views.CHAT ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.showChats}>
                            <FontAwesomeIcon icon={duotone('messages')} /> <span className='chattab'>{this.props.t("messages")}</span>
                        </Col>
                        <Col className={
                            "fs-4 pb-3 " +
                            (this.state.view === Views.ONHOLD ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.showOnHold}>
                            <FontAwesomeIcon icon={duotone('reply-clock')} /> <span className='chattab'>{this.props.t("postponed")}</span>
                        </Col>
                        <Col className={
                            "fs-4 pb-3 " +
                            (this.state.view === Views.HISTORY ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                        } onClick={this.showHistory}>
                            <FontAwesomeIcon icon={duotone('clock')} /> <span className='chattab'>{this.props.t("history")}</span>
                        </Col>
                    </Row>
                    <>
                        <div style={this.state.view === Views.CHAT ? {} : { display: 'none' }}>
                            <LiveChats />
                        </div>
                        <div style={this.state.view === Views.ONHOLD ? {} : { display: 'none' }}>
                            <PostponedChats />
                        </div>
                        <div style={this.state.view === Views.HISTORY ? {} : { display: 'none' }}>
                            <HistoryChats />
                        </div>
                    </>
                </Col>
                <Col xs={9} className="interaction-window">
                    <Outlet></Outlet>
                </Col>
            </Row >
        );
    };
}
const mapStateToProps = (state) => {
    return {
        interactions: state.interaction.searchResult,

    };
};


function WithNavigate(props) {
    let navigate = useNavigate();
    return <Interactions {...props} navigate={navigate} />
}



export default compose(connect(mapStateToProps, { sort, search, selectInteraction }), withTranslation())(WithNavigate);
